const StateEnum = {
  NOT_INIT: 'not-init',
  INITIALZING: 'initializing',
  INITIALIZED: 'initialized',
  INITIALIZATION_FAILED: 'initialization-failed',
  ERROR: 'error',
  FAILED: 'failed',
  NEED_UPDATE: 'need-update'
};

/**
 * API状态工具
 * @param {Object} params
 * @param {string} params.api api
 * @param {boolean} params.log 是否打印日志
 */
export function useApiStateManager({ api, log }) {
  /**@type {keyof StateEnum} */
  let $state = StateEnum.NOT_INIT;

  /** @type {keyof typeof StateEnum[]} */
  let needUpdateList = [
    StateEnum.NEED_UPDATE,
    StateEnum.NOT_INIT,
    StateEnum.ERROR,
    StateEnum.FAILED,
    StateEnum.INITIALIZATION_FAILED
  ];

  return {
    StateEnum,
    state: $state,
    needUpdate() {
      this.setState('NEED_UPDATE');
    },
    /**
     * 设置状态
     * @param {keyof typeof StateEnum} state
     */
    setState(state) {
      $state = StateEnum[state];
      if (log)
        console.info(`%c[API]-[${api}]`, 'color: lightskyblue; font-weight: 600', '状态-', $state);
    },
    /**
     * 获取当前状态
     */
    getState() {
      return $state;
    },
    /**
     * 设置哪些状态需要更新
     * @param {typeof needUpdateList} list
     */
    setNeedUpdateList(list) {
      needUpdateList = list;
    },
    /**
     * 是否需要更新
     */
    isNeedUpdate() {
      return needUpdateList.includes($state);
    }
  };
}
